import { COLORS, RADIUS, fontFamilyFor } from "../../theme";

const heading = (isArabic) => (isArabic ? fontFamilyFor("ar") : "'Playfair Display', serif");
const body = (isArabic) => fontFamilyFor(isArabic ? "ar" : "en");

export const Style = {
  page: {
    background: COLORS.dark,
    color: "#fff",
  },
  hero: {
    padding: { xs: "48px 20px 32px", md: "80px 48px 40px" },
    textAlign: "center",
  },
  h1: (isArabic) => ({
    fontFamily: heading(isArabic),
    fontSize: { xs: "2.4rem", md: "4.5rem" },
    fontWeight: 700,
    mb: "24px",
    background: `linear-gradient(135deg, #fff 0%, ${COLORS.peach} 100%)`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  }),
  heroSubtitle: (isArabic) => ({
    fontFamily: body(isArabic),
    fontSize: { xs: "1rem", md: "1.3rem" },
    color: "rgba(255,255,255,0.7)",
    maxWidth: "700px",
    mx: "auto",
  }),
  section: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: { xs: "32px 20px", md: "64px 48px" },
  },
  h2: (isArabic) => ({
    fontFamily: heading(isArabic),
    fontSize: { xs: "1.8rem", md: "3rem" },
    fontWeight: 700,
    color: COLORS.peach,
    textAlign: "center",
    mb: { xs: "24px", md: "48px" },
  }),
  steps: {
    display: "flex",
    flexDirection: "column",
    gap: { xs: "32px", md: "48px" },
    mt: "24px",
  },
  step: (isArabic) => ({
    display: "grid",
    gridTemplateColumns: { xs: "64px 1fr", md: "100px 1fr" },
    gap: { xs: "16px", md: "32px" },
    alignItems: "start",
    direction: isArabic ? "rtl" : "ltr",
  }),
  stepNumber: {
    width: { xs: "64px", md: "90px" },
    height: { xs: "64px", md: "90px" },
    background: COLORS.forest,
    border: `2px solid ${COLORS.gold}`,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: { xs: "1.6rem", md: "2.4rem" },
    fontWeight: 800,
    color: COLORS.gold,
    boxShadow: "0 0 0 6px rgba(212,175,55,0.08)",
  },
  stepTitle: (isArabic) => ({
    fontFamily: heading(isArabic),
    fontSize: { xs: "1.3rem", md: "2rem" },
    color: COLORS.peach,
    mb: "10px",
    fontWeight: 700,
  }),
  stepBody: (isArabic) => ({
    fontFamily: body(isArabic),
    fontSize: { xs: "1rem", md: "1.15rem" },
    lineHeight: 1.8,
    color: "rgba(255,255,255,0.8)",
  }),
  featuresGrid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "1fr 1fr",
      md: "repeat(3, 1fr)",
    },
    gap: "24px",
    mt: "24px",
  },
  feature: {
    background: COLORS.gray,
    padding: "28px",
    borderRadius: RADIUS.card,
    border: "1px solid rgba(255,255,255,0.05)",
  },
  featureIcon: {
    width: "56px",
    height: "56px",
    borderRadius: "12px",
    background: `linear-gradient(135deg, ${COLORS.gold}, ${COLORS.peach})`,
    color: COLORS.forest,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: "18px",
    fontSize: "26px",
  },
  featureTitle: (isArabic) => ({
    fontFamily: body(isArabic),
    fontSize: "1.3rem",
    fontWeight: 700,
    color: COLORS.peach,
    mb: "10px",
  }),
  featureBody: (isArabic) => ({
    fontFamily: body(isArabic),
    color: "rgba(255,255,255,0.8)",
    lineHeight: 1.6,
  }),
  ctaSection: {
    background: COLORS.forest,
    padding: { xs: "48px 20px", md: "96px 48px" },
    textAlign: "center",
    mt: "32px",
  },
  ctaSubtitle: (isArabic) => ({
    fontFamily: body(isArabic),
    fontSize: { xs: "1.05rem", md: "1.3rem" },
    color: "rgba(255,255,255,0.8)",
    mb: "32px",
  }),
  ctaButtons: (isArabic) => ({
    display: "flex",
    flexDirection: isArabic ? "row-reverse" : "row",
    justifyContent: "center",
    gap: "16px",
    flexWrap: "wrap",
  }),
  btnPrimary: {
    py: "14px",
    px: "32px",
    borderRadius: RADIUS.pill,
    background: COLORS.peach,
    color: COLORS.dark,
    fontWeight: 700,
    "&:hover": { background: COLORS.gold },
  },
  btnOutline: {
    py: "14px",
    px: "32px",
    borderRadius: RADIUS.pill,
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.3)",
    color: "#fff",
    fontWeight: 700,
    "&:hover": { borderColor: COLORS.gold, color: COLORS.gold },
  },
};
